import React, { Component } from 'react';
import PropType from 'prop-types';
import styles from './overlay.module.scss';

class Overlay extends Component {
    closeOnEscape = e => {
        const { closeModalCallback } = this.props;
        if (e.keyCode === 27) {
            if (closeModalCallback) {
                closeModalCallback(e);
            }
            e.preventDefault();
        }
    };

    componentDidMount() {
        window.addEventListener('keydown', this.closeOnEscape);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.closeOnEscape);
    }

    render() {
        const { children, closeModalCallback, style } = this.props;

        return (
            <div
                style={style}
                className={styles.overlay}
                onClick={closeModalCallback}>
                {children}
            </div>
        );
    }
}

Overlay.propTypes = {
    children: PropType.node,
    closeModalCallback: PropType.func,
    style: PropType.object
};

export default Overlay;
